import { Component, Prop, h } from '@stencil/core';

import dynamicEntryActions from '../../../actions/actions.dynamic-entry';
import { DynamicEntryWorkflow } from '../../../utils/utils.landing';
import { DynamicEntryStartButton } from '../DynamicEntryStartButton';

@Component({
  tag: 'dynamic-entry-ineligible',
  styleUrl: 'dynamic-entry-ineligible.css',
})
export class DynamicEntryIneligible {
  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.Unassigned;
  @Prop() vin: string = '';
  @Prop() seeValuesLink: string = '';
  @Prop() changeVehicle: Function = () => {};
  @Prop() shouldShowIneligibleButton: boolean = true;

  onProceedWithoutICOClick() {
    dynamicEntryActions.onProceedWithoutICO();
  }

  render() {
    const hyperlinkClass = {
      'flex justify-center text-xs mt-5 flex-wrap': true,
      'flex-col items-center gap-3 text-center': this.dynamicEntryWorkflow === DynamicEntryWorkflow.Unassigned,
    };

    return (
      <div class="flex flex-col rounded dynamic-entry-ineligible-base-font">
        <div class="text-sm">
          <div class="flex font-medium">
            <icon-alert class="dynamic-entry-ineligible-icon-alert mx-2 mt-0.5 w-4 h-4" />
            {this.dynamicEntryWorkflow !== DynamicEntryWorkflow.DigitalRetail && (
              <div>
                <h4 class="font-bold">Your vehicle doesn't qualify for an Instant Cash Offer for one or more reasons:</h4>
                <ul class="pl-4">
                  <li>Year, Make, Model and/or Style</li>
                  <li>Salvage title or other title issues</li>
                  <li>Flood/water damage</li>
                  <li>Frame damage</li>
                  <li>Mileage or odometer issues</li>
                  <li>Police, government, taxi or livery vehicle</li>
                </ul>
              </div>
            )}
            {this.dynamicEntryWorkflow === DynamicEntryWorkflow.DigitalRetail && (
              <div>
                <h4>Your vehicle doesn't qualify for an Instant Cash Offer.</h4>
              </div>
            )}
          </div>
        </div>
        {this.dynamicEntryWorkflow === DynamicEntryWorkflow.DigitalRetail && this.shouldShowIneligibleButton && (
          <DynamicEntryStartButton class="mt-8" label="Proceed without Instant Cash Offer" whenClicked={() => this.onProceedWithoutICOClick()} color="tertiary" />
        )}
        <div class={hyperlinkClass}>
          {this.dynamicEntryWorkflow === DynamicEntryWorkflow.Unassigned && (
            <ico-hyperlink data-testid="bi-btn-see-values" content="primary" href={this.seeValuesLink}>
              See the Trade-in and Private Party Values
            </ico-hyperlink>
          )}
          <ico-hyperlink
            data-testid="bi-btn-change-vehicle"
            content="primary"
            onClick={(e) => {
              e.preventDefault();
              this.changeVehicle();
            }}
            href="">
            Change Vehicle
          </ico-hyperlink>
        </div>
      </div>
    );
  }
}
